module.exports = __webpack_public_path__ + "static/media/scroll_right.7fe5c103.gif";